// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"147":"c5a91796","272":"e32c1db1","686":"31d6cfe0"}[chunkId] + ".chunk.css";
};